import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

new Swiper('.posts-slider__slider', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 'auto',
  spaceBetween: 20,
  scrollbar: {
    el: '.posts-slider__slider__nav .swiper-scrollbar',
  },
  navigation: {
    nextEl: '.posts-slider__slider__nav .swiper-button-next',
    prevEl: '.posts-slider__slider__nav .swiper-button-prev',
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  a11y: {
    prevSlideMessage: _x('Go to previous slide', 'swiper accessibility', 'vtx'),
    nextSlideMessage: _x('Go to next slide', 'swiper accessibility', 'vtx'),
  },
});
